import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { IUserEmailSettings } from '@kinet-open-network/shared/data-access/model';

export class UserEmailSettingsService {
  protected http = inject(HttpClient);

  endpoint = '/emails/user/settings';

  updateNotificationsSettings(data: Partial<IUserEmailSettings>) {
    return this.http.put<IUserEmailSettings>(this.endpoint, data);
  }

  getNotificationsSettings() {
    return this.http.get<IUserEmailSettings>(this.endpoint);
  }
}
